module.exports = __webpack_public_path__ + "static/img/whatwedo-vertical.c8fa0717.jpg";